import { supabase } from './supabase';
import { parseAccounts, type TenantAccount } from './accounts';

/**
 * Comptes admin (brique C) — lecture Supabase via RPC sécurisée `list_tenant_accounts`
 * (super_admin only, cf. sql/24_tenant_accounts.sql). Logique pure dans accounts.ts.
 */

export interface LoadAccountsResult {
  ok: boolean;
  accounts: TenantAccount[];
  error?: string;
}

/** Charge tous les comptes admin de tous les restos (réservé au super_admin). */
export async function loadTenantAccounts(): Promise<LoadAccountsResult> {
  const { data, error } = await supabase.rpc('list_tenant_accounts');
  if (error) {
    return { ok: false, accounts: [], error: error.message };
  }
  return { ok: true, accounts: parseAccounts(data) };
}
